import { render, staticRenderFns } from "./OperationServices.vue?vue&type=template&id=54895b74&scoped=true"
import script from "./OperationServices.vue?vue&type=script&lang=js"
export * from "./OperationServices.vue?vue&type=script&lang=js"
import style0 from "./OperationServices.vue?vue&type=style&index=0&id=54895b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54895b74",
  null
  
)

export default component.exports